module.exports = __webpack_public_path__ + "static/media/itsamatch.21c10b26.png";